import './PageHero.css';

/**
 * Shared page hero: bold heading with optional back arrow and subtitle.
 * @param {string|React.ReactNode} title - Main heading
 * @param {string} [subtitle] - Optional description below title
 * @param {string} [count] - Optional count e.g. "(3 Venues)"
 * @param {function} [onBack] - If provided, shows a back arrow that calls this when clicked
 * @param {string} [className] - Optional extra class for the wrapper
 */
function PageHero({ title, subtitle, count, onBack, className = '' }) {
  return (
    <header className={`page-hero ${onBack ? 'page-hero--with-back' : ''} ${className}`.trim()}>
      <div className="page-hero__bar">
        {onBack ? (
          <button
            type="button"
            className="page-hero__back"
            onClick={onBack}
            aria-label="Go back"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M19 12H5M12 19l-7-7 7-7" />
            </svg>
          </button>
        ) : null}
        <div className="page-hero__content">
          <h1 className="page-hero__title">
            {title}

          </h1>
          {subtitle ? <p className="page-hero__subtitle">{subtitle}</p> : null}
        </div>
      </div>
    </header>
  );
}

export default PageHero;
